export const PasscodePageStyles = {
  contentContainer: "flex flex-col gap-3.5",
  inputWrapper: "w-full mx-auto flex flex-col gap-4",
  forgotPasscodeContainer: "w-full mx-auto flex justify-start sm:mb-2 mb-1",
  forgotPasscodeButton: "text-sm md:text-md font-semibold",
  buttonContainer: "w-full",
  disabledButton: "grayscale"
};